import { useCallback, useEffect } from 'react';

import { CrossAppEvents, DataHandoverEventDetails } from '@xemplo/cross-app-events';
import { TOKEN_STORAGE_KEY } from '@xemplo/custom-axios';
import { tracker } from '@xemplo/tracking';
import { useAppSettings } from '@xemplo/xemplo-app-settings';

export function useMobileHandover() {
  const { setDsPersonaId, setHrInstanceUrl, setHasTokenHandover } = useAppSettings();

  // From the mobile app, we expect to receive a post message event
  // with the data we need to bootstrap the app
  // (dsPersonaId, instanceUrl, token)
  // Once we receive it, we store the token in session storage
  // and the rest of the data in the app settings context
  // We also set a flag to indicate that we received the token from the mobile app
  const handleMessage = useCallback(
    ({ data }: MessageEvent<DataHandoverEventDetails>) => {
      if (data.type !== CrossAppEvents.MobileDataHandover) return;
      // `instanceUrl` is the mobile handover contract name for the HR instance URL.
      const { dsPersonaId, instanceUrl, token } = data.data;

      setDsPersonaId(dsPersonaId);
      setHrInstanceUrl(instanceUrl);
      setHasTokenHandover(true);
      sessionStorage.setItem(TOKEN_STORAGE_KEY, token);
      dsPersonaId && tracker.setUserId(dsPersonaId);
    },
    [setDsPersonaId, setHasTokenHandover, setHrInstanceUrl],
  );

  useEffect(() => {
    // Subscribes to `window.postMessage` event.
    // This is injected by the mobile app and received here, once!
    // Hence we don't need to clean up the listener
    window.addEventListener('message', handleMessage, { once: true });

    // Notify the mobile app that we are ready to receive the data
    window.dispatchEvent(new CustomEvent(CrossAppEvents.MobileDataHandover));
  }, [handleMessage]);
}
